import { client } from '../common/client';
import type {
  ConvertCurrencyRequest,
  ConvertCurrencyResponse,
  GetAddressDetailsRequest,
  GetAddressDetailsResponse,
  GetGeoLocationRequest,
  GetGeoLocationResponse,
  GetPostalCodeRequest,
  GetPostalCodeResponse,
  SearchAddressRequest,
  SearchAddressResponse,
} from './utils/types';

export const deviceAPIClient = {
  /**
   * Fetch geo location information by IP address
   */
  getGeoLocation: async (params: GetGeoLocationRequest): Promise<GetGeoLocationResponse> =>
    client.get('/device/getGeoLocation', { params }).then((res) => res.data),
  /**
   * Search address suggestions using Google Places Autocomplete API
   */
  getSearchAddress: async (params: SearchAddressRequest): Promise<SearchAddressResponse> =>
    client.get('/device/searchAddress/streetAddress', { params }).then((res) => res.data),
  /**
   * Get address details using Google Places Details API
   */
  getAddressDetails: async (params: GetAddressDetailsRequest): Promise<GetAddressDetailsResponse> =>
    client.get('/device/addressDetails', { params }).then((res) => res.data),
  getPostalCode: async (params: GetPostalCodeRequest): Promise<GetPostalCodeResponse> =>
    client.get('/device/searchAddress/postalCode', { params }).then((res) => res.data),
  convertCurrency: async (params: ConvertCurrencyRequest): Promise<ConvertCurrencyResponse> =>
    client.get('/device/convertCurrency', { params }).then((res) => res.data),
};
